<div class="naplozaras-admin">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Naplózárás</ion-card-title>
      <ion-card-subtitle>
        A lezárt időszak óráin nem lehet témát, hiányzót, könyvelést vagy elmaradt-jelölést módosítani,
        és a beírt óra nem törölhető. A helyettesítés kiírása (ki tartotta az órát) a zárás után is rögzíthető.
        Javításhoz az időszakot – akár csak egy kollégának, határidővel – fel lehet oldani; minden zárás és
        feloldás a naplóban marad.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <h3 class="cim">Automatikus zárás</h3>
      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="3">
            <ion-select label="Mód" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="b.zaras_mod">
              <ion-select-option value="nincs">Nincs</ion-select-option>
              <ion-select-option value="napi">Napi</ion-select-option>
              <ion-select-option value="heti">Heti</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="3" *ngIf="b.zaras_mod === 'napi'">
            <ion-input type="number" min="0" max="60" label="Hány nap után" label-placement="stacked" fill="outline"
                       [(ngModel)]="b.napi_nap"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="3" *ngIf="b.zaras_mod === 'heti'">
            <ion-select label="A következő hét melyik napján" label-placement="stacked" fill="outline" interface="popover"
                        [(ngModel)]="b.heti_nap">
              <ion-select-option *ngFor="let n of NAPOK" [value]="n.e">{{ n.n }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="3" *ngIf="b.zaras_mod !== 'nincs'">
            <ion-select label="Hány órakor" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="b.zaras_ora">
              <ion-select-option *ngFor="let o of ORAK" [value]="o">{{ o }}:00</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <p class="szabaly">{{ szabalySzoveg }}</p>
            <p class="halvany" *ngIf="maZarul && b.modositva">A mai nap zárása a mentett szabály szerint: {{ maZarul }}.</p>
            <p class="halvany" *ngIf="b.modositotta">Utoljára módosította: {{ b.modositotta }}, {{ b.modositva }}.</p>
          </ion-col>
          <ion-col size="12" class="gombok">
            <ion-button (click)="mentes()" [disabled]="ment || betolt">{{ ment ? 'Mentés…' : 'Mentés' }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <h3 class="cim">Kézi zárás vagy feloldás</h3>
      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="2">
            <ion-select label="Mit" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="uj.tipus">
              <ion-select-option value="nyit">Feloldás</ion-select-option>
              <ion-select-option value="zar">Zárás</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="6" sizeMd="2">
            <ion-input type="date" label="Ettől" label-placement="stacked" fill="outline" [(ngModel)]="uj.tol"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="2">
            <ion-input type="date" label="Eddig" label-placement="stacked" fill="outline" [(ngModel)]="uj.ig"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="3" *ngIf="uj.tipus === 'nyit'">
            <ion-select label="Kinek (üres = mindenkinek)" label-placement="stacked" fill="outline" interface="popover"
                        [(ngModel)]="uj.tanar">
              <ion-select-option value="">Mindenkinek</ion-select-option>
              <ion-select-option *ngFor="let a of allomany" [value]="a.adid">{{ a.nev }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="3" *ngIf="uj.tipus === 'nyit'">
            <ion-input type="datetime-local" label="Meddig él (üres = visszavonásig)" label-placement="stacked" fill="outline"
                       [(ngModel)]="uj.lejar"></ion-input>
          </ion-col>
          <ion-col size="12">
            <ion-input label="Ok (kötelező)" label-placement="stacked" fill="outline" [(ngModel)]="uj.ok"
                       placeholder="pl. a szeptemberi hiányzások pótlása"></ion-input>
          </ion-col>
          <ion-col size="12" class="gombok">
            <ion-button (click)="idoszakFelvesz()">{{ uj.tipus === 'zar' ? 'Lezárás' : 'Feloldás' }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <table class="naplo" *ngIf="idoszakok.length">
        <thead><tr><th>Mit</th><th>Időszak</th><th>Kinek</th><th>Lejár</th><th>Ok</th><th>Rögzítette</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let s of idoszakok" [class.visszavont]="s.visszavonva">
            <td>{{ s.tipus === 'zar' ? 'Zárás' : 'Feloldás' }}</td>
            <td class="nowrap">{{ s.tol }}<span *ngIf="s.ig !== s.tol"> – {{ s.ig }}</span></td>
            <td>{{ s.tanar ? (s.tanar_nev || s.tanar) : (s.tipus === 'nyit' ? 'mindenki' : '') }}</td>
            <td class="nowrap">{{ s.lejar || '' }}</td>
            <td>{{ s.ok }}</td>
            <td>{{ s.letrehozta }}<br><span class="halvany">{{ s.letrehozva }}</span>
              <span class="halvany" *ngIf="s.visszavonva"><br>visszavonta: {{ s.visszavonta }}, {{ s.visszavonva }}</span></td>
            <td><ion-button *ngIf="!s.visszavonva" size="small" fill="outline" color="medium" (click)="visszavon(s)">Visszavonás</ion-button></td>
          </tr>
        </tbody>
      </table>

      <h3 class="cim">Törölt, már beírt órák</h3>
      <p class="halvany">
        A beírt (naplózott) óra törléskor nem vész el: a teljes adatával archívumba kerül. Innen visszaállítható
        az órarendbe – ha a helyén azóta nem áll másik óra, és a nap nincs lezárva.
      </p>
      <ion-grid>
        <ion-row>
          <ion-col size="6" sizeMd="3">
            <ion-input type="date" label="Ettől" label-placement="stacked" fill="outline" [(ngModel)]="toroltTol"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input type="date" label="Eddig" label-placement="stacked" fill="outline" [(ngModel)]="toroltIg"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="3">
            <ion-button fill="outline" (click)="toroltBetolt()">Listázás</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
      <table class="naplo" *ngIf="torolt.length">
        <thead><tr><th>Óra</th><th>Tanár</th><th>Téma</th><th>Törölte</th><th>Ok</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let t of torolt" [class.visszavont]="t.visszaallitva">
            <td class="nowrap">{{ t.datum }} {{ t.ora }}. óra</td>
            <td>{{ tanarNev(t.tanar) }}</td>
            <td>{{ t.tema || '–' }}</td>
            <td>{{ t.torolte_nev || t.torolte }}<br><span class="halvany">{{ t.torolve }}</span></td>
            <td>{{ t.torles_oka }}</td>
            <td>
              <ion-button *ngIf="!t.visszaallitva" size="small" fill="outline" (click)="visszaallit(t)">Visszaállítás</ion-button>
              <span class="halvany" *ngIf="t.visszaallitva">visszaállítva: {{ t.visszaallitva }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </ion-card-content>
  </ion-card>
</div>
